import { Assignment } from '../../shared/feedbacks.model';
import { Data } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-feedback-assignment',
  templateUrl: './feedback-assignment.component.html',
  styleUrls: ['./feedback-assignment.component.scss']
})
export class FeedbackAssignmentComponent implements OnInit {
  @Input() assignment: Assignment;
  @Input() set nextState(value) {
    this.asTs = moment(new Date(this.assignment.asTs)).fromNow();
    this.asTsFormat = moment(new Date(this.assignment.asTs)).format('LLL');
    if (value !== undefined) {
      this.daysBetween = this.daysBetweenFunc(new Date(this.assignment.asTs), new Date(value.asTs));
    }
  }

  public daysBetween = null;
  public asTs = null;
  public asTsFormat = null;
  public isTimeShow = false;
  public isModalShow: Boolean = false;
  constructor() { }

  private daysBetweenFunc = (date1, date2) => moment(date2).from(moment(date1), true);
  public toggleTime = () => this.isTimeShow = !this.isTimeShow;
  public hasImage = () => !!this.assignment.asImages[length];
  public toogleImages = (bl: boolean) => this.isModalShow = bl;

  ngOnInit() { }

}




// WEBPACK FOOTER //
// /ng-app/src/app/feedbacks/feedback-assignments/feedback-assignment/feedback-assignment.component.ts